<template>
    <div v-if="$store.state.connected" class="dashboard-leave">
      <DashboardLeave />
    </div>
</template>

<script>
    import DashboardLeave from "@/components/Dashboard/DashboardLeave.vue";
    import router from "../router/index.js";
    
    export default {
        name: "Leave",
        data(){
            return{
            }
        },
        components: {
            DashboardLeave,
        },
        created: function() {
            if (!this.$store.state.connected) {
                router.push('connexion');
            } 
        }
    };
</script>